import React, {useState,useEffect} from "react";
import "./Album.css";
import img001 from "../Games/Puzzle/001.png";
import img002 from "../Games/Puzzle/002.png";
import img003 from "../Games/Puzzle/003.png";
import img004 from "../Games/Puzzle/004.png";
import img005 from "../Games/Puzzle/005.png";

export default  function AlbumS1() {
    const [English, setEnglish] = useState(true);
    const [CurrentState, setCurrentState] = useState("top");
    const [CurrentImg, setCurrentImg] = useState(1);
    const [Move, setMove] = useState(false);
    
    const ChangeToChinese =()=>{
        setEnglish(false);
    }

    const ChangeToEnglish =()=>{
        setEnglish(true);
    }
    
    useEffect(()=>{
        document.getElementById("BotImg").style.visibility = "hidden";

        setTimeout(()=>{
            setMove(true);
        },800)
    },[])


    const MoveLeft =()=>{
        if (Move === true){ 
            if (CurrentImg === 1){
                if(CurrentState === "top"){
                    document.getElementById("TopImg").style.marginLeft = "0px";
                    document.getElementById("BotImg").style.marginLeft = "-500%";
                    document.getElementById("TopImg").style.visibility = "hidden";
                    document.getElementById("BotImg").style.visibility = "visible";
                    setCurrentState("bot")
                }else if (CurrentState === "bot"){
                    document.getElementById("TopImg").style.marginLeft = "-500%";
                    document.getElementById("BotImg").style.marginLeft = "0px";
                    document.getElementById("BotImg").style.visibility = "hidden";
                    document.getElementById("TopImg").style.visibility = "visible";
                    setCurrentState("top")
                } 
                setCurrentImg(5)
            }if (CurrentImg === 2){
                if(CurrentState === "top"){
                    document.getElementById("TopImg").style.marginLeft = "-100%";
                    document.getElementById("BotImg").style.marginLeft = "-600%";
                }else if (CurrentState === "bot"){
                    document.getElementById("BotImg").style.marginLeft = "-100%";
                    document.getElementById("TopImg").style.marginLeft = "-600%";
                }
                setCurrentImg(1)            
            }if (CurrentImg === 3){
                if(CurrentState === "top"){
                    document.getElementById("TopImg").style.marginLeft = "-200%";
                }else if (CurrentState === "bot"){
                    document.getElementById("BotImg").style.marginLeft = "-200%";
                }   
                setCurrentImg(2)         
            }if (CurrentImg === 4){
                if(CurrentState === "top"){
                    document.getElementById("TopImg").style.marginLeft = "-300%";
                }else if (CurrentState === "bot"){
                    document.getElementById("BotImg").style.marginLeft = "-300%";
                } 
                setCurrentImg(3)           
            }else if (CurrentImg === 5){
                if(CurrentState === "top"){
                    document.getElementById("TopImg").style.marginLeft = "-400%";
                }else if (CurrentState === "bot"){
                    document.getElementById("BotImg").style.marginLeft = "-400%";
                } 
                setCurrentImg(4)
            }

            setMove(false);
            setTimeout(()=>{
                setMove(true);
            },800)
            }
    }

    const MoveRight =()=>{
        if (Move === true){ 
            if (CurrentImg === 1){
                if(CurrentState === "top"){
                    document.getElementById("TopImg").style.marginLeft = "-200%";                
                }else if (CurrentState === "bot"){
                    document.getElementById("BotImg").style.marginLeft = "-200%";
                } 
                setCurrentImg(2)
            }if (CurrentImg === 2){
                if(CurrentState === "top"){
                    document.getElementById("TopImg").style.marginLeft = "-300%";
                }else if (CurrentState === "bot"){
                    document.getElementById("BotImg").style.marginLeft = "-300%";
                }
                setCurrentImg(3)            
            }if (CurrentImg === 3){
                if(CurrentState === "top"){
                    document.getElementById("TopImg").style.marginLeft = "-400%";
                }else if (CurrentState === "bot"){
                    document.getElementById("BotImg").style.marginLeft = "-400%";
                }   
                setCurrentImg(4)         
            }if (CurrentImg === 4){
                if(CurrentState === "top"){
                    document.getElementById("TopImg").style.marginLeft = "-500%";
                    document.getElementById("BotImg").style.marginLeft = "0px";
                }else if (CurrentState === "bot"){
                    document.getElementById("TopImg").style.marginLeft = "0px";
                    document.getElementById("BotImg").style.marginLeft = "-500%";
                } 
                setCurrentImg(5)           
            }else if (CurrentImg === 5){
                if(CurrentState === "top"){
                    document.getElementById("TopImg").style.marginLeft = "-600%";
                    document.getElementById("BotImg").style.marginLeft = "-100%";
                    document.getElementById("TopImg").style.visibility = "hidden";
                    document.getElementById("BotImg").style.visibility = "visible";
                    setCurrentState("bot")
                }else if (CurrentState === "bot"){
                    document.getElementById("TopImg").style.marginLeft = "-100%";
                    document.getElementById("BotImg").style.marginLeft = "-600%";
                    document.getElementById("BotImg").style.visibility = "hidden";
                    document.getElementById("TopImg").style.visibility = "visible";
                    setCurrentState("top")
                } 
                setCurrentImg(1)
            }

            setMove(false);
            setTimeout(()=>{
                setMove(true);
            },800)
        } 
    }

    return(
        <div>
        {English?(    
            <>
            <div className="AlbumS1">
                <h1> Album Style1</h1>
                <div className="AlbumS1-Language" onClick={ChangeToChinese}> <h3>中文</h3></div>

                <div  className="AlbumS1-Top" id="TopImg">
                        <img src={img005} alt=""/>
                        <img src={img001} alt=""/>
                        <img src={img002} alt=""/>
                        <img src={img003} alt=""/>
                        <img src={img004} alt=""/>
                        <img src={img005} alt=""/>
                        <img src={img001} alt=""/>
                </div>

                <div  className="AlbumS1-Bot" id="BotImg">
                        <img src={img005} alt=""/>
                        <img src={img001} alt=""/>
                        <img src={img002} alt=""/>
                        <img src={img003} alt=""/>
                        <img src={img004} alt=""/>
                        <img src={img005} alt=""/>
                        <img src={img001} alt=""/>
                </div>

                <button  className="ButtonS1-Left" onClick={MoveLeft}>{"<<"}</button>
                <button  className="ButtonS1-Right" onClick={MoveRight}>{">>"}</button>
            </div>
            </>
        ):(
            <>
            <div className="AlbumS1">
                <h1> 相册 样式1</h1>
                <div className="AlbumS1-Language" onClick={ChangeToEnglish}> <h3>English</h3></div>

                <div  className="AlbumS1-Top" id="TopImg">
                        <img src={img005} alt=""/>
                        <img src={img001} alt=""/>
                        <img src={img002} alt=""/>
                        <img src={img003} alt=""/>
                        <img src={img004} alt=""/>
                        <img src={img005} alt=""/>
                        <img src={img001} alt=""/>
                </div>

                <div  className="AlbumS1-Bot" id="BotImg">
                        <img src={img005} alt=""/>
                        <img src={img001} alt=""/>
                        <img src={img002} alt=""/>
                        <img src={img003} alt=""/>
                        <img src={img004} alt=""/>
                        <img src={img005} alt=""/>
                        <img src={img001} alt=""/>
                </div>

                <button  className="ButtonS1-Left" onClick={MoveLeft}>{"<<"}</button>
                <button  className="ButtonS1-Right" onClick={MoveRight}>{">>"}</button>
            </div>
            </>
        )}
        </div>
    )
}